import React from 'react';
import { string, bool } from 'prop-types';
import styled from 'styled-components';
import ImagePlaceholder from '@bbc/psammead-image-placeholder';
import Message from '../Message';

var Canonical = function Canonical(_ref) {
  var src = _ref.src,
      placeholderSrcset = _ref.placeholderSrcset,
      title = _ref.title,
      placeholderSrc = _ref.placeholderSrc,
      service = _ref.service,
      noJsMessage = _ref.noJsMessage,
      showPlaceholder = _ref.showPlaceholder,
      showLoadingImage = _ref.showLoadingImage,
      darkMode = _ref.darkMode;
  var backgroundStyle = "\n    background-image: url(".concat(placeholderSrc, ");\n    background-repeat: no-repeat;\n    background-size: contain;\n  ");
  var LoadingImageWrapper = /*#__PURE__*/styled.div.withConfig({
    displayName: "LoadingImageWrapper",
    componentId: "fuo2ed-0"
  })(["position:absolute;left:0;top:0;width:100%;height:100%;"]);
  var StyledIframe = /*#__PURE__*/styled.iframe.withConfig({
    displayName: "StyledIframe",
    componentId: "fuo2ed-1"
  })(["", ";border:0;left:0;overflow:hidden;position:absolute;top:0;width:100%;height:100%;", ""], showLoadingImage ? "z-index: 1" : '', showPlaceholder ? backgroundStyle : null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledIframe, {
    src: src,
    title: title,
    allow: "autoplay; fullscreen",
    scrolling: "no",
    gesture: "media",
    allowFullScreen: true
  }), showLoadingImage && /*#__PURE__*/React.createElement(LoadingImageWrapper, null, /*#__PURE__*/React.createElement(ImagePlaceholder, {
    ratio: 56.25,
    darkMode: darkMode
  })), /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement(Message, {
    service: service,
    message: noJsMessage,
    placeholderSrc: placeholderSrc,
    placeholderSrcset: placeholderSrcset
  })));
};

Canonical.propTypes = {
  src: string.isRequired,
  placeholderSrcset: string,
  title: string.isRequired,
  placeholderSrc: string,
  service: string.isRequired,
  noJsMessage: string.isRequired,
  showPlaceholder: bool.isRequired,
  showLoadingImage: bool.isRequired,
  darkMode: bool.isRequired
};
Canonical.defaultProps = {
  placeholderSrc: null,
  placeholderSrcset: ''
};
export default Canonical;